import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  templateUrl: 'private-layout.component.html',
  styleUrls: ['private-layout.component.scss'],
})
export class PrivateLayoutComponent {}
